var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451.5 383.3",
    style: {
      enableBackground: "new 0 0 451.5 383.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.7,377.7c0-1.2-0.1-2.4-0.1-3.6c0-55.3,0-110.6,0.1-166c0-3-0.8-4.7-3.5-6.3c-47.8-27.5-95.6-55.1-143.3-82.7 c-1-0.6-2.1-1.1-3.5-1.9c-0.1,1.3-0.3,2.3-0.3,3.4c0,55.7,0,111.4-0.1,167.1c0,2.7,1.1,3.8,3.2,4.9c47.9,27.6,95.7,55.2,143.6,82.9 c1.1,0.7,2.2,1.4,3.3,2.2C212.2,377.7,212.4,377.7,212.7,377.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.4,118.3c-1.4,0.7-2.5,1.2-3.5,1.7c-16.8,9.7-33.6,19.4-50.5,29c-2.3,1.3-3.2,2.8-3.1,5.4c0.1,12.5,0,25,0.1,37.5 c0,2.4-0.8,3.7-2.9,4.7c-7.2,3.5-14.3,7.3-21.4,10.9c-0.9,0.5-1.9,0.8-3.4,1.5c0-14.1,0-27.7,0-41.9c-1.4,0.7-2.3,1.1-3.1,1.6 c-19.6,11.3-39.3,22.7-59,33.9c-1.8,1-2.5,2.2-2.5,4.3c0.1,55.7,0,111.4,0.1,167.1c0,0.6,0.1,1.2,0.1,2.2c1-0.4,1.9-0.7,2.6-1.2 c48-27.7,96-55.4,144-83.1c1.9-1.1,2.6-2.3,2.6-4.6c-0.1-55.3,0-110.7-0.1-166C389.6,120.5,389.5,119.6,389.4,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9,94.2c6.4,3.7,12.4,7.2,18.4,10.6c44.3,25.6,88.6,51.2,132.9,76.8c2.4,1.4,4.1,1.3,6.5,0c20.5-11.8,41-23.5,61.5-35.2 c0.4-0.2,0.7-0.5,1.4-1c-1.2-0.8-2.2-1.5-3.2-2c-49.1-28.4-98.3-56.7-147.3-85.2c-2.6-1.5-4.6-1.5-7.2,0 c-19.6,11.3-39.4,22.5-59.1,33.7C74.7,92.5,73.6,93.2,71.9,94.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,38.4c18.3,10.6,36,20.8,53.7,31.1C255,88.3,287.5,107,320,125.9c2.3,1.3,3.9,1.3,6.2,0c17.1-10,34.4-19.9,51.6-29.9 c0.9-0.5,1.8-1.1,3.1-1.9c-5.3-3.1-10.3-6-15.2-8.9c-45.3-26.2-90.7-52.3-136-78.6c-2.4-1.4-4.1-1.5-6.5,0 c-16.9,10-33.9,19.7-50.9,29.6C171.2,36.8,170.2,37.5,168.7,38.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduit);
export default __webpack_public_path__ + "static/media/produit.905c2c89237cc047125058d872912804.svg";
export { ForwardRef as ReactComponent };